<template>
<div class="orderItem">
	<div class="orderItem-top">
		订单号：<a :href="detailUrl" target="_blank">{{info.orderNo}}</a>
		<span class="orderItem-top-status">{{info.statusName||info.orderStatusDesc||''}}</span>
	</div>
	<div class="orderItem-body">
		<div class="orderItem-body-flex">
			<div class="orderItem-body-flex-1 orderItem-body-title">
				{{info.productName}}
				<span class="orderItem-body-subtitle" v-if="info.subjectMatter&&info.subjectMatter[0]&&info.subjectMatter[0].scheme"> {{info.subjectMatter[0].scheme}}</span>
			</div>
			<div class="orderItem-body-flex-1 align-right">
				订单创建时间：{{info.createTime}}
			</div>
		</div>
		<div class="orderItem-body-flex">
			<div class="orderItem-body-flex-1">
				订单金额：<span class="price-color">{{info.orderAmount||info.totalAmount||'0'}} 元</span>
			</div>
			<div class="orderItem-body-flex-1 align-right">
				<!-- status：2已支付 11对公支付的已支付还未确认 -->
				<span v-if="isPaid">订单支付时间：{{info.paymentTime}}</span>
				<Button 
					type="primary" 
					size="small" 
					@click="toPay(info.orderNo)" 
					v-if="info.productCode.indexOf('APP')==-1&&(isUnpaid)">立即支付</Button>
				<Button size="small" @click="toCancel(info.orderNo)" v-if="info.productCode.indexOf('APP')==-1&&isUnpaid">取消订单</Button>
				<Button size="small" @click="toEdit(info.orderNo)" v-if="info.status==1&&(info.productCode=='GSCGZZRX'||info.productCode=='GSCGZZRXPC'||info.productCode=='GSCGZZRXPCUPD'||info.productCode=='GSCGZZRXPCUPDA')">修改订单</Button>
				<!-- <Button size="small" @click="toRest(info.orderNo)" v-if="info.status==3&&(info.productCode=='GSCGZZRX'||info.productCode=='GSCGZZRXPC')&&info.canRebuy==1" type="primary">{{info.isCorrect?'批单':'订单'}}再次投保</Button> -->
				<Button size="small" @click="toRest(info.orderNo)" v-if="info.status==3&&(info.productCode=='GSCGZZRXPC'||info.productCode=='GSCGZZRXPCUPD'||info.productCode=='GSCGZZRXPCUPDA')&&info.canRebuy==1&&!info.isCorrect" type="primary">{{info.isCorrect?'批单':'订单'}}再次投保</Button>
			</div>
		</div>
		<div class="orderItem-body-flex" v-if="isPaid">
			<div class="orderItem-body-flex-1 align-right">
				支付方式：{{info.payTypeName||info.paymentSourceDesc}}
			</div>
		</div>
		<div class="orderItem-body-flex" v-if="isPaid">
			<div class="orderItem-body-flex-1" v-if="info.pointAmount">
				抵扣金额：<span class="price-color">{{info.pointAmount||0}} 元</span>
			</div>
			<div class="orderItem-body-flex-1 align-right">
				支付金额：<span class="price-color">{{info.amount||info.buyerPayAmount||0}} 元</span>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
	},
	data () {
		return {
		}
	},
	computed: {
		isPaid(){
			// 企业雇主责任险status，其他的orderStatus
			return this.info.status=='2'||this.info.orderStatus=='PAID'
		},
		isUnpaid(){
			return this.info.status==1||this.info.orderStatus=='UNPAID'
		},
		detailUrl(){
			if(this.info.bizId){
				// 通用框架
				return `/haierProduct.html#/my/order-detail/${this.info.orderNo}/common`
			}else{
				return `/haierProduct.html#/my/order-detail/${this.info.orderNo}`
			}
		}
	},
	methods: {
		// 立即支付
		async toPay(orderNo){
			if(this.info.bizId){
				// 通用框架
				window.open(`/common.html#/common-pay/${orderNo}`)
			}else{
				if (this.info.productCode=='QYTTGZZRXAPPUPD') { // 20211118 平安雇主险新增金额校验
					await this.$axios.post('/employerLiability/checkOrderChange',{orderNo:this.info.orderNo})
					window.open(`/common.html#/new-pay?orderNo=${orderNo}&productCode=${this.info.productCode||''}`)
				} else {
					window.open(`/common.html#/new-pay?orderNo=${orderNo}&productCode=${this.info.productCode||''}`)
				}
			}
		},
		// 取消订单
		toCancel(orderNo){
			this.confirm('确认取消订单？',()=>{
				let url=this.info.bizId?'/broker/order/close':'/employerLiability/cancelOrder.json'
				this.$axios.post(url,{
					orderNo:orderNo
				}).then(res=>{
					this.toast('取消成功')
					this.$emit('on-load')
				});
			})
		},
		// 待支付的订单，允许修改订单
		toEdit () {
			window.open(`/haierProduct.html#/my/order-detail/${this.info.orderNo}?orderType=1`)
		},
		// 已关闭的订单，允许重新投保
		toRest () {
			if (this.info.isCorrect) this.toIsCorrect()
			// else window.open(`haierProduct.html#/company-group-employergs/fillin/${this.info.policyId}?reset=1&orderNo=${this.info.orderNo}&productCode=GSCGZZRXPC`)
			else window.open(`haierProduct.html#/company-group-employergs/fillin/${this.info.policyId}?reset=1&orderNo=${this.info.orderNo}&productCode=GSCGZZRXPCUPDA`)
			// else window.open(`haierProduct.html#/company-group-employergs/fillin/${this.info.policyId}?reset=1&orderNo=${this.info.orderNo}&productCode=${this.info.productCode}`)
		},
		toIsCorrect () {
			this.$axios.post('/employerLiability/checkUnPaidOrder.json',{
				id:this.info.policyId
			}).then(res=>{
				if(res){
					this.$router.push(`/company-group-employergs/edit/${this.info.policyId}?reset=1&orderNo=${this.info.orderNo}`)
				}
			});
		}
	},
}
</script>
<style scoped lang="less">
	.orderItem{
		border: 1px solid #eaeaea;
		margin-top: 10px;
		color: #333;
		&-top{
			padding: 10px;
			font-size: 14px;
			color:#aaa;
			border-bottom: 1px solid #eaeaea;
			&-status{
				float: right;
				color: #333;
			}
		}
		&-body{
			padding: 10px 0;
			&-flex{
				display: flex;
				padding: 5px  10px;
				font-size: 14px;
				&-1{
					flex: 1;
				}
			}
			&-title{
				font-size: 16px;
				font-weight: bold;
			}
			&-subtitle{
				font-size: 14px;
				font-weight: normal;
				color: #333;
			}
			.price-color{
				color: #FF6600;
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/OrderItem.vue